<p>
  start-survey-without-data works!
</p>
